import React, { useCallback, useEffect, useState } from "react";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IFilterSearchInput {
    setValue: (v: string) => void;
}

function FilterSearchInput({ setValue }: IFilterSearchInput) {
    const [searchText, setSearchText] = useState("");

    const handleChange = useCallback((e: any) => {
        setSearchText(e.target.value);
    }, []);

    useEffect(() => {
        setValue(searchText);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);

    return (
        <div className="searchWrap">
            <FontAwesomeIcon icon={faSearch} />
            <input value={searchText} placeholder="Search" onChange={handleChange} />
        </div>
    );
}

export default FilterSearchInput;
